<script setup>
import { useReferenceWorkspace } from "./referenceWorkspace";
import ReferenceComments from "@/components/ReferenceComments.vue";
import ReferenceHistory from "@/components/ReferenceHistory.vue";
const { reference, history, setSectionRef } = useReferenceWorkspace();
</script>

<template>
  <div
    class="reference-activity-grid grid min-w-0 gap-6 2xl:col-span-12 2xl:grid-cols-12"
  >
    <section
      id="comments"
      :ref="(el) => setSectionRef('comments', el)"
      class="min-w-0 scroll-mt-24 2xl:col-span-6"
    >
      <div class="mb-3">
        <div
          class="text-xs font-semibold uppercase tracking-[0.2em] text-slate-400"
        >
          Comments
        </div>
        <h2 class="text-xl font-semibold text-slate-900 dark:text-slate-100">
          Comments
        </h2>
      </div>
      <ReferenceComments :reference_id="reference.data.id" />
    </section>

    <section
      id="history"
      :ref="(el) => setSectionRef('history', el)"
      class="min-w-0 scroll-mt-24 2xl:col-span-6"
    >
      <div class="mb-3">
        <div
          class="text-xs font-semibold uppercase tracking-[0.2em] text-slate-400"
        >
          History
        </div>
        <h2 class="text-xl font-semibold text-slate-900 dark:text-slate-100">
          History
        </h2>
      </div>
      <ReferenceHistory ref="history" :reference_id="reference.data.id" />
    </section>
  </div>
</template>
